export const EARNEST_PROTOCOL = {
    title: '租房定金协议',
    abstraction: '鉴于乙方已对甲方出租房屋的整体状况及附属设施有所了解，并有意向与甲方签定正式《房屋租赁合同》，为保证《房屋租赁合同》的签订，现甲乙双方就乙方支付甲方定金等事宜签订本协议。',
    protocols: [
        {
            title: '专用条款',
            clauses: [
                {
                    subtitle: '一. 签约双方',
                    examples: [
                        { text: '甲方（出租方）：_________' },
                        { text: '身份证号：___________________________' },
                        { text: '证件人像面照片：', caption: '示例', src: require('@/assets/identity.png') },
                        { text: '联系方式：_________', separate: true },
                        { text: '乙方（承租方）：_________' },
                        { text: '身份证号：___________________________' },
                        { text: '证件人像面照片：', caption: '示例', src: require('@/assets/identity.png')  },
                        { text: '联系方式：_________' }
                    ]
                },
                {
                    subtitle: '二. 租赁标的',
                    intro: '房屋坐落：[                                    ]'
                },
                {
                    subtitle: '三. 租赁期限',
                    intro: '[      ]年[  ]月[  ]日起至[      ]年[  ]月[  ]日'
                },
                {
                    subtitle: '四. 押金、租金及付款方式',
                    details: [
                        '押金_______元',
                        '租金每月_______元，____个月一付'
                    ]
                },
                {
                    subtitle: '五. 定金及正式租赁合同签订',
                    details: [
                        '乙方支付甲方定金_______元',
                        '租赁合同签订日：如无另外约定，甲乙双方应在上述租赁期限前（包括当天）签订正式租赁合同。',
                        '签订正式房屋租赁合同，推荐使用平台电子合同功能签订，也可以签订纸质合同。'
                    ]
                },
                {
                    subtitle: '六. 补充条款'
                }
            ]
        },
        {
            title: '通用条款',
            clauses: [
                {
                    subtitle: '一、材料准备及合同生效',
                    details: [
                        { text: '签订正式房屋租赁合同时，甲方应提供本人有效身份证、本出租房源的购买或租赁凭证（包括租赁合同及同意转租声明）或其他房屋权利证明文件。乙方应带好本人有效身份证，自行核实甲方所提供的证件及复印件、合同等相应文件。' },
                        { text: '本协议若签订纸质合同经双方签字后生效，若在本平台签订电子合同，经双方确认后生效，待正式房屋租赁合同签订后租房定金转化为房屋租金。' },
                    ]
                },
                {
                    subtitle: '二. 违约及违约金支付',
                    details: [
                        { text: '甲乙双方任何一方未能如期签订正式房屋租赁合同可视为违约。' },
                        { text: '甲乙双方任何一方未按本协议约定内容签订正式房屋租赁合同可视为违约。' },
                        { text: '本协议签定后至正式《房屋租赁合同》签订时，如甲方违约，则双倍返还定金于乙方；如乙方违约，则定金由甲方没收。' }
                    ]
                },
                {
                    subtitle: '三、其他',
                    details: [
                        { text: '本协议系电子文本，由平台留存，签约双方可通过本平台自行下载打印。' },
                        { text: '甲乙双方若有补充条款则以补充条款为准，若无补充条款，则以本协议通用条款为准。' }
                    ]
                }
            ]
        }
    ]
}